import { defaultBTColor } from 'api/theme/colors';

export const webStyles = ({ pageHeader, spacing: { unit } }) => {
  const { background, ...pageHeaderContent } = pageHeader;
  return {
    pageHeader: {
      background,
      padding: [0, 7.5 * unit]
    },
    pageHeaderContent: {
      ...pageHeaderContent,
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
      padding: [0.2 * pageHeader.heightNum, 0],
      '& > *': {
        // fix hanging text getting chopped from overflow to enable ellipses test overflow
        paddingBottom: 2
      },
      '& :last-child': {
        flexShrink: 0
      }
    },
    fdicClass: {
      paddingTop: 3 * unit
    },
    pageTitle: {
      ...pageHeader.title
    }
  };
};

export const nativeStyles = ({ pageHeader, spacing: { unit }, typography: { mainTitle } }) => {
  const { background, ...pageHeaderContent } = pageHeader;
  return {
    pageHeader: {
      background,
      padding: [1 * unit, 2.5 * unit]
    },
    pageHeaderContent: {
      ...pageHeaderContent,
      alignItems: 'center',
      justifyContent: 'flex-start',
      display: 'flex',
      padding: 0,
      height: 'auto',

      '& > *': {
        // fix hanging text getting chopped from overflow to enable ellipses test overflow
        paddingBottom: 2
      },
      '& :last-child': {
        flexShrink: 0
      },
      '& svg': {
        width: '20px',
        height: '20px',
        fill: '#fff',
        marginRight: unit * 2
      }
    },
    fdicClass: {
      padding: [1.5 * unit, 0, 1 * unit]
    },
    clickable: {
      cursor: 'pointer'
    },
    pageTitle: {
      fontFamily: mainTitle.fontFamily,
      textTransform: 'none',
      fontSize: unit * 3.75
    }
  };
};

const themeDefaults = ({
  header: {
    color: headerColor,
    direction = 'to bottom',
    fontSize: headerFontSize,
    gradientEnd = defaultBTColor,
    gradientStart = defaultBTColor,
    header,
    height: headerHeight
  } = {},
  palette: { text },
  spacing: { unit },
  typography: {
    title: { fontWeight }
  }
}) => {
  const heightNum = Math.max(+(header || headerHeight || '80').replace(/\D/gi, ''), 60);

  return {
    background: `linear-gradient(${direction}, ${gradientStart}, ${gradientEnd})`,
    color: headerColor || text.light,
    height: `${heightNum}px`,
    heightNum,

    title: {
      fontFamily: 'Barlow Condensed',
      fontSize: headerFontSize || `${0.35 * heightNum}px`,
      fontWeight,
      marginRight: unit,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }
  };
};

export default themeDefaults;
